<template>
  <transition-group
    tag="div"
    class="message-container"
    name="message-fade"
  >
    <div
      v-for="item in messages"
      :key="item.id"
      class="message"
      :class="'message--' + item.type"
      role="alert"
    >
      <span class="message__icon" aria-hidden="true">{{ iconMap[item.type] }}</span>
      <span class="message__text">{{ item.message }}</span>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'MessageHost',
  data () {
    return {
      messages: [],
      iconMap: {
        success: '✓',
        warning: '!',
        error: '×',
        info: 'i'
      }
    }
  },
  methods: {
    add ({ message, type = 'info', duration = 3000 }) {
      const id = Date.now() + Math.random()
      this.messages.push({ id, message, type })
      if (duration > 0) {
        setTimeout(() => this.remove(id), duration)
      }
      return id
    },
    remove (id) {
      this.messages = this.messages.filter(m => m.id !== id)
    }
  }
}
</script>

<style>
.message-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
  width: 100%;
  max-width: 420px;
  padding: 0 16px;
  box-sizing: border-box;
}

.message {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 200px;
  max-width: 100%;
  padding: 12px 18px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 24px rgba(15, 40, 80, 0.14);
  border: 1px solid rgba(30, 100, 180, 0.12);
  font-size: 14px;
  line-height: 1.45;
  color: #263238;
  pointer-events: auto;
}

.message__icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

.message__text {
  flex: 1;
  word-break: break-word;
}

.message--success .message__icon {
  background: #43a047;
}

.message--warning .message__icon {
  background: #fb8c00;
}

.message--error .message__icon {
  background: #e53935;
}

.message--info .message__icon {
  background: #1a6fd0;
}

.message--success {
  border-color: rgba(67, 160, 71, 0.35);
}

.message--warning {
  border-color: rgba(251, 140, 0, 0.35);
}

.message--error {
  border-color: rgba(229, 57, 53, 0.35);
}

.message--info {
  border-color: rgba(26, 111, 208, 0.35);
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue